import {
  SearchEntityMasterRequest,
  DetailEntityMasterRequest,
  UpdateEntityMasterRequest,
  DeleteEntityMasterRequest,
  DetailEntityMasterResponse,
  SearchEntityMasterRecord,
  SearchEntityMasterResponse,
} from 'api-types/src/types/entity-master';
import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type AccountMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchEntityMasterRecord[];
  filterSearchData: SearchEntityMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  accountDetail: DetailEntityMasterResponse | {};
  success: boolean;
};

const initialState: AccountMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  accountDetail: {},
  success: false,
};

export const accountMasterSlice = createSlice({
  name: 'accountMaster',
  initialState,
  reducers: {
    filterAccount: (state, action: { payload: SearchEntityMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterAccountSuccess: (state, action: { payload: SearchEntityMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterAccountFailure: (state) => {
      state.loading = false;
    },
    getDetailAccountById: (state, action: { payload: DetailEntityMasterRequest }) => {
      state.loading = true;
    },
    getDetailAccountByIdSuccess: (state, action: { payload: DetailEntityMasterResponse }) => {
      state.loading = false;
      state.accountDetail = action.payload;
    },
    getDetailAccountByIdFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerAccount: (state, action: { payload: UpdateEntityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerAccountSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerAccountFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateAccount: (state, action: { payload: UpdateEntityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updateAccountSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateAccountFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteAccount: (state, action: { payload: DeleteEntityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deleteAccountSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteAccountFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataAccount: (state) => {
      state.accountDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterAccount,
  filterAccountSuccess,
  filterAccountFailure,
  setLoadingExportExcel,
  getDetailAccountById,
  getDetailAccountByIdSuccess,
  getDetailAccountByIdFailure,
  registerAccount,
  registerAccountSuccess,
  registerAccountFailure,
  updateAccount,
  updateAccountSuccess,
  updateAccountFailure,
  deleteAccount,
  deleteAccountSuccess,
  deleteAccountFailure,
  cleanDataAccount,
  cleanData,
} = accountMasterSlice.actions;

export default accountMasterSlice.reducer;
